export { default as CustomDropDown } from './form/CustomDropDown'
export { default as CustomTextArea } from './form/CustomTextArea'
export { default as CustomDatePicker } from './form/CustomDatePicker'
export { default as CustomInput } from './form/CustomInput'
export { default as ActionButton } from './ActionButton'
export { default as Error } from './Error'
export { default as CustomChipsGroup } from './CustomChipsGroup'
export { default as CustomRadio } from './CustomRadio'
export { default as CustomCollapse } from './CustomCollapse'
export { default as CustomCollapseItem } from './CustomCollapseItem'
export { default as FooterButtons } from './FooterButtons'
export { default as CustomTitleDivider } from './CustomTitleDivider'
export { default as RadioButtonBigSquare } from './RadioButtonBigSquare'
export { default as Empty } from './Empty'
export { default as CustomAutoComplete } from './CustomAutoComplete'
export { default as AutocompleteAndCreate } from './AutocompleteAndCreate'
export { default as CalloutAlert } from './CalloutAlert'

// Lista de colores
const colors = Object.freeze({
  GREEN: 'green',
  BROWN: 'brown',
  YELLOW: 'yellow',
  PINK: 'pink',
  VIOLET: 'violet',
})

export const Colors = colors
